import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { template } from 'lodash'

const TEXT = { fontSize: 12, fill: '#5F5E5A' }
const TITLE = { fontSize: 14, fontWeight: 'bold', fill: '#2C2C2A' }
const INFO_LETTER = { fontSize: 13, fill: '#5F5E5A' }
const SELECT_LETTER = { fontSize: 14, fontWeight: 'bold', fill: '#1D9E75' }
const RECALL = { stroke: '#888780', strokeWidth: 0.5, strokeDasharray: '4 3', fill: 'none' }
const INFO_LINE = { stroke: '#888780', strokeWidth: 1.2, markerStart: 'url(#piezoSchemaInfo)', markerEnd: 'url(#piezoSchemaInfo)' }
const SELECT_LINE = { stroke: '#1D9E75', strokeWidth: 2, markerStart: 'url(#piezoSchemaSelect)', markerEnd: 'url(#piezoSchemaSelect)' }

const Marker = ({ id, color, size }) => (
    <marker id={id} viewBox='0 0 10 10' refX='8' refY='5' markerWidth={size} markerHeight={size} orient='auto-start-reverse'>
        <path d='M2 1L8 5L2 9' fill='none' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </marker>
)

Marker.propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
}

const PiezometryReferenceLevelSchema = ({ ng }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 680 610' role='img' fontFamily='Arial, Helvetica, sans-serif' style={{ width: '100%', height: 'auto' }}>
        <defs>
            <Marker id='piezoSchemaAxis' color='#5F5E5A' size={6} />
            <Marker id='piezoSchemaInfo' color='#888780' size={6} />
            <Marker id='piezoSchemaSelect' color='#1D9E75' size={5} />
        </defs>

        <text style={TEXT} x='40' y='80'>{template(i18n.refLevelSchemaAxis)({ ng })}</text>
        <line x1='110' y1='495' x2='110' y2='95' stroke='#5F5E5A' strokeWidth='1.5' markerEnd='url(#piezoSchemaAxis)' />
        <text style={TEXT} x='100' y='114' textAnchor='end'>{i18n.refLevelSchemaLandmark}</text>
        <text style={TEXT} x='100' y='144' textAnchor='end'>{i18n.refLevelSchemaGround}</text>
        <text style={TEXT} x='100' y='244' textAnchor='end'>{i18n.refLevelSchemaWaterTable}</text>
        <text style={TEXT} x='100' y='384' textAnchor='end'>{i18n.refLevelSchemaSensor}</text>
        <text style={TEXT} x='100' y='444' textAnchor='end'>{i18n.refLevelSchemaBottom}</text>
        <text style={TEXT} x='100' y='494' textAnchor='end'>{template(i18n.refLevelSchemaZero)({ ng })}</text>

        <rect x='160' y='140' width='120' height='100' fill='#D3D1C7' />
        <rect x='320' y='140' width='120' height='100' fill='#D3D1C7' />
        <rect x='160' y='240' width='120' height='230' fill='#B5D4F4' />
        <rect x='320' y='240' width='120' height='230' fill='#B5D4F4' />
        <rect x='280' y='440' width='40' height='30' fill='#B5D4F4' />

        <rect x='280' y='240' width='40' height='200' fill='#85B7EB' />
        <rect x='262' y='132' width='76' height='8' fill='#B4B2A9' stroke='#5F5E5A' strokeWidth='0.5' />
        <line x1='280' y1='110' x2='280' y2='440' stroke='#2C2C2A' strokeWidth='1.5' />
        <line x1='320' y1='110' x2='320' y2='440' stroke='#2C2C2A' strokeWidth='1.5' />
        <line x1='280' y1='110' x2='320' y2='110' stroke='#2C2C2A' strokeWidth='1.5' />
        <line x1='300' y1='110' x2='300' y2='372' stroke='#2C2C2A' strokeWidth='1' />
        <rect x='291' y='372' width='18' height='16' rx='3' fill='#F0997B' stroke='#993C1D' strokeWidth='0.5' />

        <line style={RECALL} x1='110' y1='110' x2='280' y2='110' />
        <line style={RECALL} x1='320' y1='110' x2='560' y2='110' />
        <line style={RECALL} x1='110' y1='140' x2='160' y2='140' />
        <line style={RECALL} x1='440' y1='140' x2='530' y2='140' />
        <line style={RECALL} x1='110' y1='240' x2='160' y2='240' />
        <line style={RECALL} x1='440' y1='240' x2='600' y2='240' />
        <line style={RECALL} x1='110' y1='380' x2='291' y2='380' />
        <line style={RECALL} x1='309' y1='380' x2='560' y2='380' />
        <line style={RECALL} x1='110' y1='440' x2='160' y2='440' />
        <line style={RECALL} x1='110' y1='490' x2='600' y2='490' />

        <line style={INFO_LINE} x1='460' y1='112' x2='460' y2='138' />
        <text style={INFO_LETTER} x='468' y='129'>A</text>
        <line style={INFO_LINE} x1='550' y1='112' x2='550' y2='378' />
        <text style={INFO_LETTER} x='558' y='304'>D</text>
        <line style={INFO_LINE} x1='265' y1='242' x2='265' y2='378' />
        <text style={INFO_LETTER} x='257' y='314' textAnchor='end'>F</text>

        <line style={SELECT_LINE} x1='490' y1='112' x2='490' y2='238' />
        <text style={SELECT_LETTER} x='498' y='180'>P</text>
        <line style={SELECT_LINE} x1='520' y1='142' x2='520' y2='238' />
        <text style={SELECT_LETTER} x='528' y='195'>S</text>
        <line style={SELECT_LINE} x1='590' y1='242' x2='590' y2='488' />
        <text style={SELECT_LETTER} x='598' y='370'>N</text>

        <text style={{ ...TITLE, fill: '#1D9E75' }} x='40' y='525'>{i18n.refLevelSchemaSelectable}</text>
        <text style={TEXT} x='40' y='549'>{`P  ${i18n.refLevelSchemaDepthLandmark}`}</text>
        <text style={TEXT} x='40' y='571'>{`S  ${i18n.refLevelSchemaDepthGround}`}</text>
        <text style={TEXT} x='40' y='593'>{`N  ${template(i18n.refLevelSchemaPiezoNg)({ ng })}`}</text>
        <text style={TITLE} x='360' y='525'>{i18n.refLevelSchemaInformative}</text>
        <text style={TEXT} x='360' y='549'>{`A  ${i18n.refLevelSchemaLandmarkHeight}`}</text>
        <text style={TEXT} x='360' y='571'>{`D  ${i18n.refLevelSchemaSensorDepth}`}</text>
        <text style={TEXT} x='360' y='593'>{`F  ${i18n.refLevelSchemaWaterOnSensor}`}</text>
    </svg>
)

PiezometryReferenceLevelSchema.propTypes = {
    ng: PropTypes.string,
}

export default PiezometryReferenceLevelSchema
